// ============================================================
// TMR Portal Admin — a pessoa como ela aparece na tela da Empresa: chip e peek
//
// The picker and the quick-registration modal that used to live here are gone with the Partes mockup
// (F10): registering a person is `PartyFormModal`, over `POST/PUT /parties`, and finding one is the
// typeahead in `PartyNameField`. What is left is presentation of a person the Empresa record already
// carries — no state, no directory.
// ============================================================
import type { MouseEvent } from 'react';
import { Avatar, Btn } from './primitives';
import { ContactRows } from './ContactRows';
import type { ContactRow } from './ContactRows';
import { OverlayPortal } from './OverlayPortal';

/** A person as the peek modal shows them — the Empresa's own copy of the details, not a Party record. */
export interface PeekPerson {
  nome: string;
  cpf?: string;
  email?: string;
  telefone?: string;
  subtitle?: string;
}

export function PersonChip({ name, sub, onClick }: { name?: string | null; sub?: string; onClick?: (e: MouseEvent<HTMLButtonElement>) => void }) {
  if (!name) return <span style={{ color: 'var(--stone-400)' }}>—</span>;
  return (
    <button type="button" onClick={onClick} className="pa-person-chip">
      <Avatar name={name} size={26} />
      <span>
        <div style={{ fontSize: 13.5, fontWeight: 500, color: 'var(--ink-900)' }}>{name}</div>
        {sub && <div style={{ fontSize: 11.5, color: 'var(--fg-subtle)' }}>{sub}</div>}
      </span>
    </button>
  );
}

export function PersonPeekModal({ person, onClose }: { person: PeekPerson; onClose: () => void }) {
  const stop = (e: MouseEvent) => e.stopPropagation();
  const rows: ContactRow[] = [
    ...(person.cpf ? [{ key: 'cpf', label: 'CPF', value: person.cpf }] : []),
    { key: 'email', label: 'E-mail', value: person.email },
    { key: 'telefone', label: 'Telefone', value: person.telefone, kind: 'phone' },
  ];

  return (
    <OverlayPortal>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 85, background: 'rgba(28,30,28,0.32)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div onClick={stop} style={{ width: 380, maxWidth: '100%', background: 'var(--cream-50)', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>
          <div style={{ padding: '22px 24px 18px', borderBottom: '1px solid var(--border-default)', display: 'flex', alignItems: 'center', gap: 14 }}>
            <Avatar name={person.nome} size={44} />
            <div>
              <div className="pa-eyebrow" style={{ marginBottom: 3 }}>{person.subtitle || 'Pessoa'}</div>
              <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: 17, margin: 0, letterSpacing: '-0.01em' }}>{person.nome}</h3>
            </div>
          </div>
          <ContactRows rows={rows} />
          <div style={{ padding: '14px 24px', borderTop: '1px solid var(--border-default)', display: 'flex', justifyContent: 'flex-end' }}>
            <Btn variant="secondary" onClick={onClose}>
              Fechar
            </Btn>
          </div>
        </div>
      </div>
    </OverlayPortal>
  );
}
